// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rg-0";